



































































































































import Vue from "vue";
import { StateData } from "@/types";
import { locStr } from "@/utilities";
import MangoFpEditStep from "./MangoFpEditStep.vue";
import MangoFpEditStepDetails from "./MangoFpEditStepDetails.vue";
import * as Actions from "@/actions";
import { dataStore } from "@/main";

export default Vue.extend({
    name: "MangoFpProcessSteps",
    components: {
        MangoFpEditStep,
        MangoFpEditStepDetails,
    },
    data() {
        return {
            newStepModifyOpen: false,
            delDialogOpen: false,
            delConfirmCode: "",
            states: dataStore.state.stateList as StateData[],
        };
    },
    methods: {
        locStr: function(key: string): string {
            return locStr(key);
        },
        closeStepEdit: function() {
            this.newStepModifyOpen = false;
        },
        openStepAdd: function() {
            this.newStepModifyOpen = true;
        },
        addStepEdit: async function(param: {
            code: string;
            action: string;
            state: string;
        }) {
            const isItDone = await Actions.addNewState(
                param.action,
                param.state,
            );
            if (isItDone) {
                this.closeStepEdit();
            }
        },
        openDeleteConfirm(code: string) {
            this.delConfirmCode = code;
            this.delDialogOpen = true;
        },
        closeDialogConfirm() {
            this.delConfirmCode = "";
            this.delDialogOpen = false;
        },
        deleteStep: async function() {
            console.log("delete code: " + this.delConfirmCode);
            const isItDone = await Actions.deleteState(this.delConfirmCode);
            if (!isItDone) {
                console.log("Deleteing step failed");
                return false;
            }
            this.closeDialogConfirm();
            return true;
        },
        orderStepUp: async function(code: string) {
            console.log("Order up");
            return Actions.reOrderState(code, "up");
        },
        orderStepDown: async function(code: string) {
            console.log("Order down");
            return Actions.reOrderState(code, "down");
        },
    },
});
